export default __webpack_public_path__ + "static/media/card3.8386fd04.png";